import { render, staticRenderFns } from "./StockInvoiceEditor.vue?vue&type=template&id=544be928&"
import script from "./StockInvoiceEditor.vue?vue&type=script&lang=js&"
export * from "./StockInvoiceEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports